import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getEvaluasi = createAsyncThunk('/evaluasi/content', async (nopage) => {
    const userId = localStorage.getItem("userId")
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listEvaluasi/${userId}?page=${nopage}`, {})
    return response.data;
})

export const evaluasiSlice = createSlice({
    name: 'evaluasi',
    initialState: {
        isLoading: false,
        evaluasi: []
    },
    reducers: {


        addNewEvaluasi: (state, action) => {
            let { newEvaluasiObj } = action.payload
            state.evaluasi = [...state.evaluasi, newEvaluasiObj]
        },

        deleteEvaluasi: (state, action) => {
            let { index } = action.payload
            state.evaluasi.splice(index, 1)
        }
    },

    /*extraReducers: {
        [getEvaluasi.pending]: state => {
            state.isLoading = true
        },
        [getEvaluasi.fulfilled]: (state, action) => {
            state.evaluasi = action.payload.data
            state.isLoading = false
        },
        [getEvaluasi.rejected]: state => {
            state.isLoading = false
        },
    }*/

    extraReducers: (builder) => {
        builder
            .addCase(getEvaluasi.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getEvaluasi.fulfilled, (state, action) => {
                state.evaluasi = action.payload.data;
                state.isLoading = false;
            })
            .addCase(getEvaluasi.rejected, (state) => {
                state.isLoading = false;
            });             
    }   
})

export const { addNewEvaluasi, deleteEvaluasi } = evaluasiSlice.actions

export default evaluasiSlice.reducer